<template>
  <div class="chat-message-wrapper">
    <transition>
      <div v-if="isFirstNew" class="msg-first-new">New messages</div>
    </transition>

    <div :class="classObject"
        :title="textTitle"
    >
      <ChatModeration v-if="isModerating && !isSystem"
                      :message="message"
                      :canBan="canBan"
                      :isBanned="isBanned"
                      v-on="$listeners"
      />

      <div class="chat-message-inner">
        <div class="chat-message-sender">
                  <span v-if="showSenderName"
                        class="chat-message-sender-name">
                    <Admin v-if="message.is_staff"/>
                    {{ message.sender_name }}
                  </span>
          <span v-if="showSenderDate"
                class="chat-message-sender-date">{{ asDateTimeStamp(message.created_at, timezone) }}</span>
        </div>
        <div class="chat-message-body" v-html="htmlMessage"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {asDateTimeStamp} from '../DateTime';
import {formatRawText} from "@/utils/Text";
import {CHAT_TYPES, CHAT_SUBTYPES} from "@/components/Config";
import Admin from "@/components/icons/Admin";
import ChatModeration from "@/components/chat/ChatModeration";

export default {
  name: "ChatMessage",
  components: {
    Admin,
    ChatModeration,
  },
  props: {
    message: Object,
    myId: Number,
    prevMessage: Object,
    isFirstNew: Boolean,
    isModerating: Boolean,
    canBan: {
      type: Boolean,
      default: false
    },
    status: {
      type: Object,
      default: undefined,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  computed: {
    classObject() {
      return {
        'chat-message': true,
        'system': this.isSystem,
        'from-me': this.myId === this.message.sender_id,
        'from-other': (this.message.subtype === CHAT_SUBTYPES.MESSAGE && this.myId !== this.message.sender_id),
        'msg-staff': this.message.is_staff,
      };
    },
    isSystem() {
      return (
          this.message.type === CHAT_TYPES.ERROR ||
          this.message.type === CHAT_TYPES.SOCKET_CLOSED ||
          this.message.subtype === CHAT_SUBTYPES.CLOSED
      );
    },
    isBanned() {
      return (this.status && this.status.type === CHAT_TYPES.BANNED);
    },
    htmlMessage() {
      return formatRawText(this.message.message);
    },
    showSenderName() {
      if (!this.message.sender_name) {
        return false;
      }
      if (this.prevMessage && (this.message.sender_name === this.prevMessage.sender_name)) {
        return false;
      }
      return true;
    },
    showSenderDate() {
      if (this.prevMessage && (asDateTimeStamp(this.message.created_at) === asDateTimeStamp(this.prevMessage.created_at))) {
        return false;
      }
      return true;
    },
    textTitle() {
      if (this.message.is_staff) {
        return "Message from the managers";
      }
      return "";
    },
  },
  methods: {
    asDateTimeStamp,
  },
}
</script>

<style>
.chat-message-wrapper {
  display: flex;
  flex-direction: column;
}

.chat-message {
  align-self: auto;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 5px;
}

.chat-message.from-me {
  align-self: flex-end !important;
  background-color: #dff0d8;
  /* margin-left: 20px;*/ 
  text-align: right;
  max-width: 90%;
}

.from-me .chat-message-body {
  text-align: left;
}

.chat-message.from-other {
  align-self: flex-start;
  background-color: #eee;
  border: 0;
  margin-right: 20px;
}

.chat-message.msg-staff {
  align-self: auto;
  background-color: #ddeeff;
  margin: 0 0 5px;
}

.chat-message.system {
  align-self: auto;
  border-bottom: 5px solid #ccc;
  border-top: 5px solid #ccc;
  border-radius: 0;
  margin-top: 30px;
}

.chat-message-inner {
  padding: 3px 10px 3px;
  overflow-wrap: break-word;
}

.system .chat-message-inner {
  padding: 10px;
}

.chat-message-sender {
  color: #777;
  font-size: 10px;
  line-height: 14px;
}

.chat-message-sender-name {
  font-weight: bold;
  padding-right: 5px;
}

.chat-message-sender-name svg {
  height: 12px;
  width: 12px;
}

.chat-message-sender-date {
  font-style: italic;
}

.msg-first-new {
  transition: 2s linear all;
  border-bottom: 1px dashed #ccc;
  font-size: 10px;
  margin-bottom: 10px;
  text-align: center;
}

</style>